var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';
import { Animated, Pressable } from 'react-native';
import { CountriesListView } from './CountriesListView';
import { getCountry } from './Resources';
import { CoreConfig } from '../../../CoreConfig';
import allCountries from './Resources/countries';
import { Configuration } from '../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { component } from '../../Decorators/Component';
import { InputView } from './InputView';
import { H6View } from '../Typography/H6View';
import { CountryView } from './CountryView';
import { AnimatedView } from '../Common/AnimatedView';
export const PhoneInputView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.phoneInput,
    style(theme, mediaQuery, window, props) {
        return {
            container: {
                zIndex: 1
            },
            image: {
                marginEnd: 10
            },
            btn: Object.assign(Object.assign({}, props.disabled && {
                opacity: 0.4
            }), { flexDirection: 'row', alignItems: 'center' })
        };
    }
})((_a) => {
    var { style, code, disabled, value, onChangeText } = _a, props = __rest(_a, ["style", "code", "disabled", "value", "onChangeText"]);
    const listAnimation = useRef(new Animated.Value(0)).current;
    const [isOpen, setIsOpen] = useState(false);
    const [text, setText] = useState('');
    const textRef = useRef('');
    const [country, setCountry] = useState();
    useEffect(() => {
        if (value) {
            const newCountry = allCountries.sort((a, b) => a.priority - b.priority).find(x => value === null || value === void 0 ? void 0 : value.toString().startsWith(x.dialCode));
            if (newCountry) {
                setCountry(newCountry);
                return;
            }
        }
        let countryCode = undefined;
        if (!country && code) {
            countryCode = getCountry(code || '');
        }
        if (!countryCode || (!country && !code)) {
            countryCode = getCountry('us');
        }
        setCountry(countryCode);
    }, [code]);
    const handleSetText = useCallback((text) => {
        setText(text);
        textRef.current = text;
    }, []);
    const toggleList = useCallback(() => {
        if (disabled) {
            return;
        }
        if (isOpen) {
            return Animated.timing(listAnimation, {
                useNativeDriver: false,
                toValue: 0,
                duration: 200
            }).start(() => {
                setIsOpen(false);
            });
        }
        setIsOpen(true);
        Animated.timing(listAnimation, {
            useNativeDriver: false,
            toValue: 1,
            duration: 200
        }).start();
    }, [isOpen, disabled]);
    const hideList = useCallback(() => {
        return Animated.timing(listAnimation, {
            useNativeDriver: false,
            toValue: 0,
            duration: 200
        }).start(() => {
            setIsOpen(false);
        });
    }, []);
    const handlePress = useCallback((country) => {
        setCountry(country);
        toggleList();
        onChangeText === null || onChangeText === void 0 ? void 0 : onChangeText(`${(country === null || country === void 0 ? void 0 : country.dialCode) || ''}${text}`);
    }, [toggleList, text]);
    const handleInput = useCallback((text) => {
        handleSetText(text);
        onChangeText === null || onChangeText === void 0 ? void 0 : onChangeText(`${text ? (country === null || country === void 0 ? void 0 : country.dialCode) || '' : ''}${text}`);
    }, [country]);
    useEffect(() => {
        var _a;
        const text = (value || '').toString();
        if (text === textRef.current) {
            return;
        }
        if (!country) {
            return;
        }
        const search = text.startsWith('+')
            ? text
            : `+${value}`;
        const newCountry = allCountries.sort((a, b) => a.priority - b.priority).find(x => search.startsWith(x.dialCode));
        const newValue = search.replace(((_a = (newCountry || country)) === null || _a === void 0 ? void 0 : _a.dialCode) || '', '');
        setCountry(newCountry);
        handleSetText(newValue);
    }, [value, country]);
    return (_jsxs(AnimatedView, { children: [_jsx(InputView, Object.assign({}, props, { onChangeText: handleInput, value: text, keyboardType: "phone-pad", onFocus: hideList, disabled: disabled, beforeStyle: { padding: 13 }, before: () => country && (_jsxs(Pressable, { style: style === null || style === void 0 ? void 0 : style.btn, onPress: toggleList, children: [_jsx(CountryView, { code: country.iso2, containerStyle: style === null || style === void 0 ? void 0 : style.image }), _jsx(H6View, { textStyle: { marginBottom: 0 }, light: false, children: country.dialCode })] })) })), _jsx(CountriesListView, { visible: isOpen, topOffset: 60, leftOffset: 4, rightOffset: 4, onPress: handlePress, onClose: hideList })] }));
});
